/* eslint-disable jsx-a11y/label-has-associated-control */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import React from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core';
import car from '../../../../../../../../images/car.png';


import styles from './styles';

const ArrangeCollection = ({ classes }) => {

  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <img className={classes.image} src={car} alt={'car'} />
      </div>
      <div className={classes.column}>
        <span className={classes.mainText}>{ 'Arrange a Collection' }</span>
        <p className={classes.column}>
          <span className={classes.textDescription}>{'We\'ll collect orders from your store'}</span>
          <span className={classes.textDescription}>{'Simply call or email us below'}</span>
        </p>
        <a href="tel:0800 515 6893" className={classes.mainText}>{'0800 515 6893'}</a>
        <a href="mailto:cs@sellitback.com" className={classes.mainText}>{'cs@sellitback.com'}</a>
      </div>
    </div>
  );
};

ArrangeCollection.propTypes = {
  classes: PropTypes.object,
};

ArrangeCollection.defaultProps = {
  classes: {},
};


export default withStyles(styles)(ArrangeCollection);
